export default {
  fetchInstitutionClientData: {
    api: {
      url: 'default',
    },
    $$method: 'get',
    $$meta: {
      mock: () => 'mocks/endpoints/institutions/fetchInstitutionClientData.json',
    },
    $$config: {
      headers: (data) => data.headers.authorization,
    },
    $$makeUrl(config, { unit, clientId } ) {
      const url = 'therapist/v1/clients'
      const queryParams = new URLSearchParams()

      if (unit) queryParams.set('unit', unit)
      if (clientId) {
        queryParams.set('id', clientId)
      }

      return `${url}${queryParams.size ? `?${queryParams}` : ''}`
    },
  },
  clinical: {
    fetchPathologyList: { // TODO Will get dupl. when these task and protocols get merged. Remove ASAP
      api: {
        url: 'default',
      },
      $$method: 'get',
      $$config: {
        headers: (data) => data.headers.authorization,
      },
      $$makeUrl() {
        return 'api/v1.1/pathologies'
      },
    },
  },
}
